import { ROUTERS } from '@/constant';
import { convertNationCodeToName } from '@/utils';

import { TFunction } from 'i18next';

import HyperLink from '../common/hyper-link';
import { ColumnTypes } from '../common/table/type';

export const getColumns = (
	t: TFunction<'common'>,
	isSystemRole: boolean = true,
	fetchData: () => void
): ColumnTypes => [
	{
		align: 'center',
		title: 'ID',
		dataIndex: 'id',
		key: 'id',
		className: '!cursor-default',
		render: (id, record) =>
			isSystemRole ? (
				<HyperLink
					params={{
						id,
						pathname: ROUTERS.CM2_03,
					}}
					callback={fetchData}
				>
					{id}
				</HyperLink>
			) : (
				id
			),
	},

	{
		align: 'center',
		title: '국가',
		dataIndex: 'nationalCode',
		key: 'nationalCode',
		render: (text: string) => {
			return text ? convertNationCodeToName(text) : '-';
		},
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: '구분',
		dataIndex: 'typeName',
		key: 'typeName',
		render: (text: string) => {
			return t(`${text}` as any);
		},
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: '사업체',
		dataIndex: 'name',
		key: 'name',
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: '사업체 전화번호',
		dataIndex: 'phone',
		key: 'phone',
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: '사업체 주소',
		dataIndex: 'foreignAddress',
		key: 'foreignAddress',
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: '등록자',
		dataIndex: 'registName',
		key: 'registName',
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: '등록일',
		dataIndex: 'registDt',
		key: 'registDt',
		className: '!cursor-default',
	},
];
